import React from "react";
import styled from "@emotion/styled";
import Application from "../Form/Application";
import { GatsbyImage } from "gatsby-plugin-image";
import AniLink from "gatsby-plugin-transition-link/AniLink";
import MicroModal from "micromodal";
import tw from "twin.macro";
import { Tab, Tabs, TabList, TabPanel } from "react-tabs";
import "react-tabs/style/react-tabs.css";

const StyledModal = styled.div`
  .modal {
    &[aria-hidden="false"] {
      .overlay {
        animation: mmfadeIn 0.5s cubic-bezier(0, 0, 0.2, 1);
      }
    }
    &[aria-hidden="false"] {
      .content-wrapper {
        animation: mmslideIn 0.5s cubic-bezier(0, 0, 0.2, 1);
      }
    }
    &[aria-hidden="true"] {
      .overlay {
        animation: mmfadeOut 0.5s cubic-bezier(0, 0, 0.2, 1);
      }
    }
    &[aria-hidden="true"] {
      .content-wrapper {
        animation: mmslideOut 0.5s cubic-bezier(0, 0, 0.2, 1);
      }
    }
  }
`;

const StyledTabs = styled.div`
  .react-tabs__tab-list {
    ${tw`grid grid-cols-2 mb-10 md:mb-14 border-none`}
  }
  .react-tabs__tab {
    ${tw`text-sm text-gray-900/40 font-semibold py-2 px-4 bg-gray-50 rounded-none flex items-center justify-center w-full border-none transition-colors duration-300 ease-linear`}
  }
  .react-tabs__tab--selected {
    ${tw`text-white bg-primary-600`}
    svg {
      path {
        ${tw`text-white`}
      }
    }
  }
`;

const Modal = () => {
  if (typeof window !== "undefined") {
    MicroModal.init({
      openTrigger: "data-modal-open",
      closeTrigger: "data-modal-close",
      disableFocus: true,
      disableScroll: true,
      awaitOpenAnimation: true,
      awaitCloseAnimation: true,
    });
  }
  const handleClose = () => {
    MicroModal.close("modal-apply");
  };
  return (
    <StyledModal>
      <div className="modal relative hidden z-50" id="modal-apply" aria-hidden="false">
        <div
          className="overlay fixed flex items-center justify-center top-0 right-0 left-0 bottom-0 bg-black outline-none"
          tabIndex="-1"
          data-modal-close
          // onClick={handleClose}
        >
          <div
            className="content-wrapper bg-white w-full h-screen overflow-auto max-w-[720px] ml-auto"
            role="dialog"
            aria-modal="true"
          >
            <div className="flex justify-between items-center pt-12 pb-4 md:py-4 px-5 border-b border-gray-100">
              <a
                href="tel:720-491-3117"
                className="text-primary-600 hover:text-primary-800 font-bold"
              >
                <i className="fas fa-phone-alt mr-1"></i> (720) 491-3117
              </a>
              <i
                className="close fal fa-times text-xl text-black hover:text-primary-600 cursor-pointer transition-all duration-300 ease-linear"
                data-modal-close
                // onClick={handleClose}
              ></i>
            </div>

            <div className="pt-8 px-4 md:px-18 pb-24">
              <header className="mb-6 md:mb-8 text-center">
                <p className="heading-three text-[#26272B]">Apply</p>
              </header>

              <StyledTabs>
                <Tabs>
                  <TabPanel>
                    <Application />
                  </TabPanel>
                </Tabs>
              </StyledTabs>
            </div>
          </div>
        </div>
      </div>
    </StyledModal>
  );
};
export default Modal;
